import React, {Component} from "react";
import {Modal, Spin, Switch} from "antd";
import cookie from "react-cookies";
import {deleteAccessPolicy, getAccessPolicyPermissionsAndMembers} from "../utils/api";
import {antdSpinLoaderIcon} from "../utils/const";

class DeletePolicy extends Component {

    constructor(props) {
        super(props);

        this.state = {
            confirmLoading: false,
            retainPermissions: true,
            users: [],
            isFetched: false,
        }
    }

    componentDidMount() {
        this.fetchPolicyUsers();
    }

    fetchPolicyUsers = () => {
        this.setState({isFetched: true})
        const organisation = cookie.load('organisation') || cookie.load('organisation_id')
        getAccessPolicyPermissionsAndMembers(organisation, this.props.policy).then((res) => {
            this.setState({users: res['members'], isFetched: false})
        })
    }

    deletePolicy = () => {
        this.setState({confirmLoading: true})
        const organisation = cookie.load('organisation') || cookie.load('organisation_id')
        deleteAccessPolicy(this.props.policy, organisation, this.state.retainPermissions).then(() => {
            this.props.closeModal(true)
            this.setState({confirmLoading: false})
        })
    }

    handleRetainPermissions = (checked) => {
        this.setState({retainPermissions: checked})
    }


    render() {

        return <Modal
            title={"Confirm, Delete Policy"}
            onOk={this.deletePolicy}
            onCancel={() => this.props.closeModal(false)}
            confirmLoading={this.state.confirmLoading}
            visible={this.props.showModal}
        >
            <Spin spinning={this.state.isFetched} indicator={antdSpinLoaderIcon}>
                <div>
                    Once, Policy is deleted all data related to it will be lost forever.
                </div>
                <div>
                    {"Do you want to delete following policy ?"}
                    <ul>
                        <li>{this.props.policy}</li>
                    </ul>
                </div>

                <div>
                    {"Users accessing this Policy"}
                    <ul>
                        {this.state.users.length > 0 ?
                            this.state.users.map((val) => <li>{val}</li>) : <li>No Users Assigned</li>}
                    </ul>
                </div>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <Switch
                        checked={this.state.retainPermissions}
                        onChange={this.handleRetainPermissions}
                    />
                    <span style={{marginLeft: 8}}>Retain Policy Permissions to assigned Users</span>
                </div>
            </Spin>
        </Modal>
    }
}

export default DeletePolicy